import { render } from "./ENT.vue?vue&type=template&id=63c7f8d8"
import script from "./ENT.vue?vue&type=script&lang=ts"
export * from "./ENT.vue?vue&type=script&lang=ts"
script.render = render

export default script